import { render } from "./aiQuestionPopup.vue?vue&type=template&id=d95ee056&scoped=true"
import script from "./aiQuestionPopup.vue?vue&type=script&lang=js"
export * from "./aiQuestionPopup.vue?vue&type=script&lang=js"

import "./aiQuestionPopup.vue?vue&type=style&index=0&id=d95ee056&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d95ee056"]])

export default __exports__